function loaderController($scope, $timeout) {
    var self = this;
    
    self.initialise = function() {
        $scope.showLoader = false;
        $scope.$watch('$ctrl.isLoading', function(newValue) {
            if (newValue === true) {
                $scope.showLoader = true;
                $('#wrapper').addClass('blur');
            }
            else {
                $timeout(function() {
                    $scope.showLoader = false;
                    $('#wrapper').removeClass('blur');
                },0);
            }
        });
    };
    
    self.initialise();
}

angular
    .module('dashboard')
    .component('loader', 
    {
        templateUrl: 'components/loader/loader.643434cc.html',
        bindings: {
            isLoading: '<'
        },
        controller: ['$scope', '$timeout', loaderController]
    });